(function () {
  'use strict';

  const MAP = {
    'Light Duty': 'Indoor-use, Low traffic areas',
    'Heavy Duty': 'Indoor / Outdoor Use, Harsh Weather',
    'Industrial Strength': 'Harsh Weather, Construction & Mining'
  };

  function updatePopupsOnly() {

    /* ? tooltip (Select Tags Type) */
    const tooltip = document.querySelector('.ptooltiptext');
    if (tooltip) {
      tooltip.querySelectorAll('p').forEach(p => {
        const strong = p.querySelector('strong');
        if (!strong) return;

        const key = strong.textContent.trim();
        if (MAP[key]) {
          p.innerHTML = `<strong>${key}</strong> - ${MAP[key]}`;
        }
      });
    }

    /* Image hover popup */
    document.querySelectorAll('.swtooltip span').forEach(span => {
      const key = span.textContent.trim();
      if (MAP[key]) {
        span.textContent = MAP[key];
      }
    });
  }

  /* Run once, after everything is rendered */
  window.addEventListener('load', function () {
    setTimeout(updatePopupsOnly, 100);
  });

})();